module.exports = __webpack_public_path__ + "img/arrow-up-from-dotted-line.9fd1ca64.svg";